/** Only relative, authenticated API paths can receive the shared session. */
export function isSchoolMediaUrl(url: unknown): url is string {
  return (
    typeof url === "string" &&
    /^\/api\/content\/school-media\/(?:books\/\d+\/cover\/|lessons\/\d+\/(?:pdf|original-pdf|minified-pdf|cover)\/|audios\/\d+\/)(?:\?[a-zA-Z0-9_=&%-]+)?$/.test(
      url,
    )
  );
}

export function schoolMaterialReturnPath(path: unknown): string | null {
  return typeof path === "string" &&
    /^\/(?:school-dashboard|school-teacher)\/materials\/\d+$/.test(path)
    ? path
    : null;
}

/** Individual and school uploads use the same authenticated media contract. */
export function isPrivateMaterialMediaUrl(url: unknown): url is string {
  return (
    typeof url === "string" &&
    /^\/api\/content\/(?:school|individual)-media\/(?:books\/\d+\/cover\/|lessons\/\d+\/(?:pdf|original-pdf|minified-pdf|cover)\/|audios\/\d+\/)(?:\?[a-zA-Z0-9_=&%-]+)?$/.test(
      url,
    )
  );
}

export function materialReturnPath(path: unknown): string | null {
  return (
    schoolMaterialReturnPath(path) ||
    (typeof path === "string" && /^\/dashboard\/my-books\/\d+$/.test(path)
      ? path
      : null)
  );
}
